/**
 * Whether the sidebar entry `key` is the page shown (`selectedKey`, from
 * Refine's `useMenu`) or leads to it. A resource without a sidebar entry
 * of its own (a game's configurations) is selected under its parent:
 * `/platform/games/gameConfigurations` keeps Platform › Games selected.
 */
export function isMenuKeySelected(
  key: string | undefined,
  selectedKey: string,
) {
  return (
    key !== undefined &&
    key !== '' &&
    (selectedKey === key || selectedKey.startsWith(`${key}/`))
  )
}
